module.exports = require("./si.d.ts");